import React from "react";
import {
	Grid,
	Divider,
	Dialog,
	Box,
	DialogActions,
	Button,
	Typography,
	DialogTitle,
	CircularProgress,
	IconButton,
} from "@material-ui/core";

import CloseIcon from "@material-ui/icons/Close";

import styles from "./TransactionDisconnected.module.css";

export default function TransactionDisconnectedModal({
	msg,
	clearError,
	codemsg,
}) {
	const staticMessage1 = `Hi!`
	const staticMessage2 = `Based on Meralco's records, your service is currently temporarily disconnected due to an unpaid balance. To restore your service, please settle your outstanding balance in full.`
	const staticMessage3 = `Payments made between 7:00AM and 9:59PM are posted in real-time. Payments made outside these hours will be posted the following day.`
	const staticMessage4 = `Once your payment is posted, your service will be restored within 24 hours. If your payment is made on a weekend or holiday, reconnection will be scheduled on the next business day.`
	const staticMessage5 = `Please note that the applicable reconnection fee will be reflected in your next bill.`
	const staticMessage6 = `Would you like to proceed?`
	const staticMessage7 = `(If you have already made your payment, please disregard this message.)`

	const dfoStaticMessage = `Hey, your account is already for disconnection. A crew might already be on its way and your payment may not be posted in time to avoid disconnection. In case your service is disconnected, you will be reconnected within the next business day from the time your payment is posted. A reconnection fee will be included on your next bill.`;
	const dfoStaticMessage2 = `Do you still want to proceed?`;
	const breakThrought = () => {
		if (codemsg === 1) {
			return (
				<>
					{dfoStaticMessage}
					<br />
					<br />
					<br />
					{dfoStaticMessage2}
				</>
			);
		} else {
			return (
				<>
					{staticMessage1}
					<br />
					<br />
					{staticMessage2}
					<br />
					<br />
					{staticMessage3}
					<br />
					<br />
					{staticMessage4}
					<br />
					<br />
					{staticMessage5}
					<br />
					<br />
					{staticMessage6}
					<br />
					<br />
					<i>{staticMessage7}</i>
				</>
			);
		}
	};
	const headerChanger = () => {
		if (codemsg === 1) {
			return "Account for Disconnection!";
		} else {
			return "Disconnected Service!";
		}
	};
	return (
		<Dialog
			disableBackdropClick
			open={true}
			classes={{ paper: styles.dialogPaper }}
		>
			<Grid
			container
			direction="row"
			justifyContent="space-between"
			alignItems="center">
				<Grid item>
					<DialogTitle>
						<Typography className={styles.countHeader}>
							{headerChanger()}
						</Typography>
					</DialogTitle>
				</Grid>
				<Grid item className={styles.closeButton}>
					<IconButton
						aria-label="close"
						onClick={() => clearError()}
					>
						<CloseIcon />
					</IconButton>
				</Grid>
			</Grid>
			<Divider />
			<Box>
				<Typography className={styles.countBody}>
					<div>{breakThrought()}</div>
				</Typography>
			</Box>

			<Divider />
			<DialogActions>
				<Button
					variant="outlined"
					className={styles.buttonLogin}
					label="close"
					onClick={() => clearError()}
				>
					Cancel
				</Button>

				<Button
					variant="outlined"
					className={styles.buttonLogout}
					label="close"
					onClick={() => clearError()}
				>
					Confirm
				</Button>
			</DialogActions>
		</Dialog>
	);
}
